import React from "react";
import {Link} from "react-router-dom";
import ButtonT from "../atoms/ButtonT";
import SearchBox from "../atoms/SearchBox";
import Title from "../atoms/Title";
import Button from "../atoms/Button";

const SearchHeader = ({
                          title,
                          number,
                          buttnText,
                          person,
                          placeholder,
                          gettext,
                          buttonSearch,
                          onClick,
                          path,
                          pathExport,
                          exportFile,
                          borderBlue,
                          hasBtn,
                          onClickB,
                          addbtn,
                          btnclick,
                          counttext
                      }) => {
    console.log("HAS BTN : ",hasBtn)
    return (
        <div className="flex flex-row justify-between items-center h-10 mb-7.5px">
            <div className="flex flex-row">
                <Title text={title}/>
                {/* Display number of items if provided */}
                {number > 0 && (
                    <span
                        className="text-dark-blue-200 text-13 flex items-center before:content-dot mr-2.5 before:pl-2.5 ">
            تعداد کل : {" "}
                        <span className="pr-1">
              {number}
                            <span className="pr-1">{counttext ? counttext : "نفر"}</span>
            </span>
          </span>
                )}
                {/* Display name of person if provided */}
                {person && <span>"{person}"</span>}
            </div>
            <div className="flex flex-row gap-3.6">
                {/* SearchBox Component */}
                <SearchBox
                    placeholder={placeholder}
                    gettext={gettext}
                    buttonSearch={buttonSearch}
                    isCancelVisible={false}
                    onCancelSearchClick={() => {
                        console.log("CLCIKKKKK")
                    }}
                />
                {/* Render button based on the condition */}
                {exportFile ? (
                    // Button for exporting file
                    <a href={path} download>
                        <ButtonT text={buttnText} onClick={onClick} borderBlue={borderBlue}/>
                    </a>
                ) : (
                    // Button for navigation or action
                    <Link to={path}>
                        <ButtonT text={buttnText} onClick={onClick} borderBlue={borderBlue}/>
                    </Link>
                )}
                {/*{
                    hasBtn && (
                        <>
                            {exportFile ? (
                                // Button for exporting file
                                <a href={pathExport} download>
                                    <ButtonT text={buttnText} onClick={onClickB} borderBlue={borderBlue}/>
                                </a>
                            ) : (
                                // Button for navigation or action
                                <Link to={path}>
                                    <ButtonT text={buttnText} onClick={onClick} borderBlue={borderBlue}/>
                                </Link>
                            )}
                        </>
                    )
                }*/}

            </div>
        </div>
    );
};

export default SearchHeader;
